import { RedirectRoute } from '../Routing/types';

const redirects: RedirectRoute[] = [
  {
    path: '/knowledge',
    redirectTo: '/knowledge/all',
  },
  {
    path: '/oxy365/*',
    paramRedirect: {
      fromPrefix: '/oxy365',
      toPrefix: '/knowledge',
    },
  },
];

export default redirects;
